// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"f451713c","131":"91e2672e","309":"dd01e8b2","583":"a91f5598","680":"ef125360","685":"f73cb27f","697":"b9a481c3","928":"712630c0","957":"9736e2ea","964":"366be1d8"}[chunkId] + ".chunk.js";
};